import { useLocation } from "react-router-dom";
import {
  /* BrandsFN, */ ProductStatus,
  catalogBrandOptions,
  productPackaging,
} from "../../constants/enum";
import { Suspense, useState } from "react";

import wrapPromise from "../../helpers/wrapPromise";
import EmptyCard from "../../components/EmptyCard";
import Card from "../../components/Card";

import { API, graphqlOperation } from "aws-amplify";
import { searchProducts } from "../../graphql/queries";
import { groupBy } from "../../components/GroupBy";
import Waiting from "../../components/Waiting";
import Footer from "../../components/Footer";
import SearchBar from "../../components/SearchBar";

const PAGE_SIZE = 50;
const ACTIVE_STATUSES = [
  ProductStatus.Launch,
  ProductStatus.Normal,
  ProductStatus.TobeDiscontinued,
];

function Catalogue() {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const bp: any = params.get("brand") ? params.get("brand") : "FL";
  const q: any = params.get("q") ? params.get("q") : "";
  const scope: any = params.get("brand") ? params.get("brand") : "ALL";
  const status: any = params.get("status") ? params.get("status") : "ALL";
  const startSearchUpdatedDate: any = params.get("updated_start")
    ? params.get("updated_start")
    : undefined;
  const endSearchUpdatedDate: any = params.get("updated_end")
    ? params.get("updated_end")
    : undefined;

  /* 
    Retrieve data from param and get data from enum via variable
    ref. https://stackoverflow.com/questions/18111657/how-to-get-names-of-enum-entries
  */
  const [brand] = useState<string>(bp);
  // const [ brandFN ] = useState<string>(BrandsFN[bp as keyof typeof BrandsFN])
  const [searchResultProducts, setSearchResultProducts] = useState<any>([]);
  const [pageFrom, setPageFrom] = useState<number>(0);

  /* Prepare brand logo */
  const brandImage: any = catalogBrandOptions.find(
    (cb) => cb.value.code === brand
  )?.value.image;

  const fecthProductByCatalogue = () => {
    let result: any = API.graphql(
      graphqlOperation(searchProducts, {
        brand,
        packaging: productPackaging.EA,
        statuses: ACTIVE_STATUSES,
        limit: PAGE_SIZE,
        from: pageFrom,
      })
    );

    return {
      result: wrapPromise(result),
    };
  };

  const sr = fecthProductByCatalogue();

  const UpdateFetchProductResult = ({ sr }: any) => {
    if (!sr) {
      return <EmptyCard message="NO SEARCH RESULT" />;
    }
    const searchResults = sr.result.read();

    const total = searchResults.data.searchProducts.total;
    const products = searchResults.data.searchProducts.items;
    const loadedCount = searchResultProducts.length + products.length;
    const hasMore = products.length === PAGE_SIZE && loadedCount < total;

    const combinedProduct = [
      ...searchResultProducts,
      ...searchResults.data.searchProducts.items,
    ];
    combinedProduct
      .map((product) => {
        if (product.category === "-") product.category = "zzz";
        return product;
      })
      .sort((a, b) => {
        return a.category
          ? a.category.localeCompare(b.category ? b.category : -1)
          : -1;
      });

    const productByCategory = groupBy(combinedProduct, "category");
    const sortedProductByCategory = Object.keys(productByCategory)
      .sort()
      .reduce((accumulator: any, key: any) => {
        accumulator[key] = productByCategory[key];
        return accumulator;
      }, {});

    let count = 0;
    if (searchResultProducts.length === 0 && products.length === 0) {
      return <EmptyCard message="RESULT NOT FOUND!" />;
    }

    return (
      <div className="flex flex-col sm:gap-3 sm:px-4">
        {Object.entries(sortedProductByCategory).map((pc: any) => {
          const catName = pc[0] !== "zzz" ? pc[0] : "No Category";
          const products = pc[1];
          return (
            <div key={(count += 1)}>
              <div className="flex flex-row justify-between">
                <span className="my-2 ml-2 text-2xl font-bold text-gray-600">
                  {catName}
                  <small className="ml-2 text-md text-sky-700">
                    ( {products.length} )
                  </small>
                </span>
              </div>
              <div className="xs:grid xs:grid-cols-1 sm:flex sm:flex-wrap sm:justify-center sm:gap-4 sm:p-4 sm:px-2">
                {products.map((product: any) => {
                  return (
                    <div
                      key={product.id}
                      className="xs:my-2 xs:mx-0 sm:max-w-lg"
                    >
                      <Card data={product} />
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
        {hasMore ? (
          <div className="flex flex-row justify-center gap-2 m-4">
            <button
              type="button"
              className="inline-block rounded bg-primary-100 px-6 pb-2 pt-2.5 text-xs font-medium uppercase leading-normal text-primary-700 transition duration-150 ease-in-out hover:bg-primary-accent-100 focus:bg-primary-accent-100 focus:outline-none focus:ring-0 active:bg-primary-accent-200"
              onClick={() => {
                setSearchResultProducts([...searchResultProducts, ...products]);
                setPageFrom(pageFrom + PAGE_SIZE);
              }}
            >
              Load More{" "}
              <span className="font-bold">
                [
                <span className="ml-2 inline-block whitespace-nowrap rounded-[0.27rem] bg-danger-100 px-[0.65em] pb-[0.25em] pt-[0.35em] text-center align-baseline text-[1.5em] font-bold leading-none text-danger-700">
                  {[...searchResultProducts, ...products].length} / {total}
                </span>{" "}
                products ]
              </span>
            </button>
          </div>
        ) : (
          <div className="flex flex-row justify-center p-2">
            <span className="font-bold uppercase">
              <span className="ml-2 inline-block whitespace-nowrap rounded-[0.27rem] bg-danger-100 px-[0.65em] pb-[0.25em] pt-[0.35em] text-center align-baseline text-[1.5em] font-bold leading-none text-danger-700">
                {[...searchResultProducts, ...products].length} / {total}
              </span>{" "}
              products
            </span>
          </div>
        )}
      </div>
    );
  };

  return (
    <>
      <div className="flex flex-row justify-center">
        <div className="w-full p-4 lg:w-3/4">
          <SearchBar
            brand={scope}
            searchInput={q}
            status={status}
            enableUpdatedDateSearch={
              startSearchUpdatedDate && endSearchUpdatedDate ? true : false
            }
            startSearchUpdatedDate={
              startSearchUpdatedDate
                ? new Date(startSearchUpdatedDate)
                : undefined
            }
            endSearchUpdatedDate={
              endSearchUpdatedDate ? new Date(endSearchUpdatedDate) : undefined
            }
          />
        </div>
      </div>
      <div className="flex flex-col justify-center pl-0 mt-2 mb-1 list-none border-b-0">
        <span className="flex justify-center my-1 font-bold text-gray-600 ">
          <a href="#!">
            <img
              className="rounded-t-lg"
              src={`/brands/${brandImage}`}
              alt=""
            />
          </a>
        </span>

        <Suspense fallback={<Waiting />}>
          <UpdateFetchProductResult sr={sr} />
        </Suspense>
      </div>
      <Footer />
    </>
  );
}

export default Catalogue;
